import { Grid, Paper } from "@mui/material";
import SnackbarAlert from "./SnackbarAlert";
import AddressChangeDialog from "./ticketForm/AddressChangeDialog";
import AttachmentsAndSubmit from "./ticketForm/AttachmentsAndSubmit";
import ConfirmationCheckboxes from "./ticketForm/ConfirmationCheckboxes";
import ContactChangeDialog from "./ticketForm/ContactChangeDialog";
import DeleteImageDialog from "./ticketForm/DeleteImageDialog";
import OpenerDetailsFields from "./ticketForm/OpenerDetailsFields";
import TermsAcceptance from "./ticketForm/TermsAcceptance";
import TicketDetailsFields from "./ticketForm/TicketDetailsFields";
import TicketFormHeader from "./ticketForm/TicketFormHeader";
import TicketNotCreatedDialog from "./ticketForm/TicketNotCreatedDialog";
import { useAddressChangeRequest } from "./ticketForm/useAddressChangeRequest";
import { useContactChangeRequest } from "./ticketForm/useContactChangeRequest";
import { useImageAttachments } from "./ticketForm/useImageAttachments";
import { useSnackbarMessage } from "./ticketForm/useSnackbarMessage";
import { useTicketForm } from "./ticketForm/useTicketForm";
import { useTicketSubmit } from "./ticketForm/useTicketSubmit";

const paperSx = {
  p: 2,
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
};

// "פתיחת קריאה" form: the customer's details, the problem, confirmations and images
function OpeningReading({ data, openedViaDevice }) {
  const { snackbar, setSnackbar, handleCloseSnackbar } = useSnackbarMessage();
  const ticketForm = useTicketForm();
  const { formData, setFormData } = ticketForm;
  const address = useAddressChangeRequest(() =>
    setFormData((prev) => ({ ...prev, confirmAddress: false }))
  );
  const contact = useContactChangeRequest(() =>
    setFormData((prev) => ({ ...prev, confirmContactPerson: false }))
  );
  const images = useImageAttachments(formData.images, setFormData, setSnackbar);
  const submit = useTicketSubmit({ data, openedViaDevice, formData, address, contact, setSnackbar });

  return (
    <>
      <Paper sx={paperSx} dir="rtl">
        <TicketFormHeader />
        <Grid container spacing={2}>
          <OpenerDetailsFields {...ticketForm} />
          <TicketDetailsFields {...ticketForm} />
          <ConfirmationCheckboxes
            {...ticketForm}
            setAddressDialogOpen={address.setAddressDialogOpen}
            setContactDialogOpen={contact.setContactDialogOpen}
          />
          <TermsAcceptance {...ticketForm} />
          <AttachmentsAndSubmit formData={formData} {...images} {...submit} />
        </Grid>
      </Paper>

      <DeleteImageDialog {...images} />
      {/* Ticket Not Created Dialog - stays open until the customer acknowledges it */}
      <TicketNotCreatedDialog open={submit.ticketNotCreatedOpen} onClose={submit.closeTicketNotCreated} />
      <AddressChangeDialog {...address} />
      <ContactChangeDialog {...contact} />

      <SnackbarAlert
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        duration={5000}
        onClose={handleCloseSnackbar}
      />
    </>
  );
}

export default OpeningReading;
